import React, { useState } from 'react';
import { RightOutlined } from '@ant-design/icons';

interface SettingsStepCardProps {
  step: number;
  title: string;
  chips: string[];
  // Shown in red in place of the chips, so a problem stays visible with the card closed
  warning?: string;
}

// Numbered settings block: closed it only shows a summary of the values as chips, opened it shows the form
const SettingsStepCard: React.FC<React.PropsWithChildren<SettingsStepCardProps>> = ({ step, title, chips, warning, children }) => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <div className={`receptionist-ai-detail-page__step${isOpen ? ' receptionist-ai-detail-page__step--open' : ''}`}>
      <button
        type="button"
        className="receptionist-ai-detail-page__step-header"
        onClick={() => setIsOpen((prev) => !prev)}
        aria-expanded={isOpen}
      >
        <span className="receptionist-ai-detail-page__step-number">{step}</span>
        <span className="receptionist-ai-detail-page__step-title">{title}</span>
        <span className="receptionist-ai-detail-page__step-chips">
          {warning ? (
            <span className="receptionist-ai-detail-page__step-chip receptionist-ai-detail-page__step-chip--warning">
              {warning}
            </span>
          ) : (
            chips.map((chip, index) => (
              <span key={index} className="receptionist-ai-detail-page__step-chip">
                {chip}
              </span>
            ))
          )}
        </span>
        <RightOutlined className="receptionist-ai-detail-page__step-chevron" />
      </button>
      {isOpen && <div className="receptionist-ai-detail-page__step-body">{children}</div>}
    </div>
  );
};

export default SettingsStepCard;
